module.exports = __webpack_public_path__ + "static/start_low_image_2-7fbce71ef2212d278f3b190070e25148.png";